const ProgressIndicator = ()=>{
    return(
        <div>
            <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="progress-steps">
              <div className="progress-item">
                <div className="progress-circle bg-success"></div>
                <p className="progress-label">Data Collection</p>
              </div>
              <div className="progress-item">
                <div className="progress-circle bg-success"></div>
                <p className="progress-label">Data Processing</p>
              </div>
              <div className="progress-item">
                <div className="progress-circle bg-secondary"></div>
                <p className="progress-label">Segmentation</p>
              </div>
              <div className="progress-item">
                <div className="progress-circle bg-secondary"></div>
                <p className="progress-label">Results</p>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="progress">
              <div
                className="progress-bar bg-success"
                style={{ width: "52%" }}
                role="progressbar"
                aria-valuenow={70}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        </div>
      </div>
    
        </div>

    )

}
export default ProgressIndicator